const translations = {
    noServiceLogged: 'No service logged yet'
};

export default translations;
